import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { MaterialModule } from 'src/app/material.module';
import { BorderouriAutomateComponent } from './borderouri-automate.component';
import { BorderouriAutomateService } from './borderouri-automate.service';

@NgModule({
    declarations: [
        BorderouriAutomateComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DataTablesModule,
        MaterialModule
    ],
    exports: [
        BorderouriAutomateComponent
    ],
    providers: [
        BorderouriAutomateService
    ]
})
export class BorderouriAutomateModule { }
